/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs */

const en_svc_rag_knowledge_assistants_work_0_badge = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum RAG tutor`)
};

const ar_svc_rag_knowledge_assistants_work_0_badge = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معلم RAG للمناهج`)
};

const bn_svc_rag_knowledge_assistants_work_0_badge = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পাঠ্যক্রম RAG শিক্ষক`)
};

const de_svc_rag_knowledge_assistants_work_0_badge = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG-Tutor für Lehrpläne`)
};

const es_svc_rag_knowledge_assistants_work_0_badge = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutor RAG de planes de estudio`)
};

const fr_svc_rag_knowledge_assistants_work_0_badge = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuteur RAG de programmes`)
};

const pt_svc_rag_knowledge_assistants_work_0_badge = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutor RAG de planos de estudo`)
};

const zh_svc_rag_knowledge_assistants_work_0_badge = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程 RAG 家教`)
};

const tr_svc_rag_knowledge_assistants_work_0_badge = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müfredat RAG eğitmeni`)
};

const ru_svc_rag_knowledge_assistants_work_0_badge = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG-тьютор по программе`)
};

const pl_svc_rag_knowledge_assistants_work_0_badge = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutor RAG do programów`)
};

/**
* | output |
* | --- |
* | "Curriculum RAG tutor" |
*
* @param {Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_work_0_badge = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Work_0_BadgeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_work_0_badge(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_work_0_badge(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_work_0_badge(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_work_0_badge(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_work_0_badge(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_work_0_badge(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_work_0_badge(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_work_0_badge(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_work_0_badge(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_work_0_badge(inputs)
	return en_svc_rag_knowledge_assistants_work_0_badge(inputs)
});
export { svc_rag_knowledge_assistants_work_0_badge as "svc_rag-knowledge-assistants_work_0_badge" }